import { ResourceListPage } from '@/features/access/pages/resource/ResourceListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/access/resource/')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["auth_resources.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ResourceListPage,
})
